
import BookemWidget from "@/components/BookemWidget";
import { Helmet } from 'react-helmet-async';

const Booking = () => {
  return (
    <>
      <Helmet>
        <title>Book a Dietician Consultation | Functional Foodie</title>
        <meta 
          name="description" 
          content="Schedule a consultation with a top dietician in Johannesburg. Book an appointment at Functional Foodie for personalised nutrition guidance. Secure your spot today!"
        />
      </Helmet>
      <div className="min-h-screen py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold text-center text-primary mb-12">Book an Appointment</h1>
          <div className="max-w-4xl mx-auto">
            <BookemWidget />
          </div>
        </div>
      </div>
    </>
  );
};

export default Booking;
